import { useCascaderState } from '../context';
import {
  InternalInput,
  InternalControl,
  InternalIndicatorSeparator,
  InternalIndicatorsContainer,
  InternalClearIndicator,
  InternalDropdownIndicator,
  InternalPlaceholder,
  InternalSingleSelectedValue,
  InternalSelectedValueContainer,
} from '../subcomponents';

/**
 * CascaderControl is responsible for rendering the input, placeholder, selected value, and indicators of the Cascader.
 */
export const CascaderControl = () => {
  const { inputRef, isClearable, isSearchMode, selectedOption } =
    useCascaderState();

  return (
    <InternalControl>
      <InternalSelectedValueContainer>
        <InternalInput inputRef={inputRef} />
        {!isSearchMode &&
          (selectedOption ? (
            <InternalSingleSelectedValue selectedOption={selectedOption} />
          ) : (
            <InternalPlaceholder />
          ))}
      </InternalSelectedValueContainer>

      <InternalIndicatorsContainer>
        {isClearable && selectedOption && <InternalClearIndicator />}
        <InternalIndicatorSeparator />
        <InternalDropdownIndicator />
      </InternalIndicatorsContainer>
    </InternalControl>
  );
};
